import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Flex, Text } from 'components/uikit';

const LOADING_MESSAGE_MIN_MS = 15000;
const LOADING_MESSAGE_MAX_MS = 25000;
const LOADING_MESSAGE_KEYS = [
  'qr_loading_processing',
  'qr_loading_searching',
  'qr_loading_selecting',
  'qr_loading_soon',
  'qr_loading_almost',
];

export const PaymentQrLoadingMessages = () => {
  const { t } = useTranslation('payments');
  const [messageIndex, setMessageIndex] = useState(0);
  const messageKey = LOADING_MESSAGE_KEYS[messageIndex] ?? '';

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const scheduleNext = () => {
      const delay =
        LOADING_MESSAGE_MIN_MS +
        Math.random() * (LOADING_MESSAGE_MAX_MS - LOADING_MESSAGE_MIN_MS);
      timeoutId = setTimeout(() => {
        setMessageIndex((index) => (index + 1) % LOADING_MESSAGE_KEYS.length);
        scheduleNext();
      }, delay);
    };
    scheduleNext();

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <Flex
      w='100%'
      justifyContent='center'
      bg='rgba(255, 255, 255, 0.8)'
      borderWidth='1px'
      borderColor='grey.border'
      borderRadius='8px'
      px='24px'
      py='16px'
      maxW='100%'
    >
      <Text fontSize='md' fontWeight='bold' textAlign='center' color='black'>
        {t(messageKey)}
      </Text>
    </Flex>
  );
};
